import React from 'react'
import style from './index.module.less'

const Tags = ({ tags = [] }) => {
  return (
    <div className={style.tags}>
      <ul className={style.container}>
        {tags.map(item => (
          <li key={item.mark_id} className={style.item}>
            <span className={style.name}>{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Tags
